import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s15_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating reactive active my-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = {
  class: "form-field-floating reactive active my-4",
  style: {"height":"75px"}
}
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = {
  key: 2,
  class: "text-red"
}
const _hoisted_9 = {
  key: 3,
  class: "text-red"
}
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = { class: "s5_mobile px-4" }
const _hoisted_12 = { class: "widget px-7 py-7" }
const _hoisted_13 = { class: "custom-upload-size margin-auto flex mb-8" }

import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import { QuillEditor } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCategoriesFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        nom: "",
        description: "",
        bg_color: "",
        image: null as any,
        image_preview: '/assets/users/default.png',
    });
    const errors = reactive({
        nom: "",
        description: "",
        bg_color: "",
        image: null
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.categorie) {
            const item = form_datas.categorie as any;
            formData.id = item.id;
            formData.nom = item.nom;
            if (item.image !== undefined) {
                formData.image_preview = item.image_url;
            }
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="La nom est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            if (formData.id != null) {
                formToUpload.append("id", `${formData.id}`);
            }
            formToUpload.append("nom", formData.nom);
            formToUpload.append("description", formData.description);
            formToUpload.append("bg_color", formData.bg_color);
            if (formData.image?.file) {
                formToUpload.append("image", formData.image.file, formData.image.name);
            }
            await axios.post(`/backoffice/market-categories/save`, formToUpload);
            router.push('/app/market/market-categories/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onFileImageUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.image_preview = uploadedFile.file_preview;
        formData.image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_upload_input = _resolveComponent("custom-upload-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Catégories Market / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
            name: "nom",
            id: "nom",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.nom]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Libellé "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['nom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['nom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "color",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.bg_color) = $event)),
            name: "bg_color",
            id: "bg_color",
            placeholder: "",
            autocomplete: "off",
            style: {"height":"75px"}
          }, null, 512), [
            [_vModelText, formData.bg_color]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "bg_color" }, "Couleur", -1))
        ]),
        (!!errors['bg_color'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errors['bg_color']), 1))
          : _createCommentVNode("", true),
        _createVNode(_unref(QuillEditor), {
          id: "description",
          content: formData.description,
          "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((formData.description) = $event)),
          contentType: "html",
          theme: "snow",
          style: {"height":"300px"}
        }, null, 8, ["content"]),
        (!!errors['description'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['description']), 1))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-semibold mb-5 text-center" }, [
          _createTextVNode("Image "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_custom_upload_input, {
            id: "photo",
            label: "Photo",
            type: "IMAGE",
            preview: formData.image_preview,
            onUploaded: onFileImageUploaded
          }, null, 8, ["preview"])
        ])
      ])
    ])
  ]))
}
}

})